module.exports = __webpack_public_path__ + "static/media/joao-pessoa-pb.38038e31.jpg";